import React from "react";
import Table from 'react-bootstrap/Table';
import "./Attendance.css";

const Attendance = () => {

  const getDate = () => {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${date} - ${month} - ${year}`;
  }

  return (
    <div className="other-cont">
      <div className="container-header">
        <h1>Welcome</h1>
        {/* <h4>{currentDate}</h4> */}
      </div>
      <Table responsive>
      <thead>
        <tr>
        <th>#</th>
        <th>Name</th>
        
        <th>Attendance</th>
          
        </tr>
      </thead>
      <tbody>
      <tr>
          <td>*</td>
          <td>Justin Imasiku</td>
          
          <td className="flex"><button>Present</button><button className="red">Absent</button></td>
          
        </tr><tr>
          <td>*</td>
          <td>Justin Imasiku</td>
          
          <td className="flex"><button>Present</button><button className="red">Absent</button></td>
          
        </tr><tr>
          <td>*</td>
          <td>Justin Imasiku</td>
          
          <td className="flex"><button>Present</button><button className="red">Absent</button></td>
          
        </tr>
       
      </tbody>
    </Table>
    </div>
  );
};

export default Attendance;
